import { createReducer, on } from '@ngrx/store';
import {
  rejectAiDataModel,
  rejectAiDataModelFailure,
  rejectAiDataModelSuccess,
  updateAIDM,
  updateAIDMSuccess,
  updateAIDMFail,
  acceptAiDataModel,
  acceptAiDataModelSuccess,
  acceptAiDataModelFailure,
  generateModelForTablePromptSuccess,
  generateModelForTablePromptFailure,
  generateModelForFieldPromptSuccess,
  generateModelForFieldPromptFailure
} from '../actions/aiapplicationdatamodel.actions';

export interface AiAppDataModelState {
  data: any;
}

export const initialState: AiAppDataModelState = {
  data: {}
};

export const aiAppDatamodelReducer = createReducer(
  initialState,
  on(rejectAiDataModel, (state, { apiConstants }) => {
    return {
      ...state,
      ...apiConstants
    };
  }),
  on(acceptAiDataModel, (state, { apiConstants }) => {
    return {
      ...state,
      ...apiConstants
    };
  }),
  on(acceptAiDataModelSuccess, (state, { acceptSuccessData }) => {
    return {
      ...state,
      ...{ acceptSuccessData }
    };
  }),
  on(acceptAiDataModelFailure, (state, { acceptFailureData }) => {
    return {
      ...state,
      ...{ acceptFailureData }
    };
  }),
  on(rejectAiDataModelSuccess, (state, { rejectSuccessData }) => {
    return {
      ...state,
      ...{ rejectSuccessData }
    };
  }),
  on(rejectAiDataModelFailure, (state, { rejectFailureData }) => {
    return {
      ...state,
      ...{ rejectFailureData }
    };
  }),
  on(updateAIDM, (state, { updApiConstants, aiDMData }) => {
    return {
      ...state,
      ...updApiConstants,
      ...aiDMData
    };
  }),
  on(updateAIDMSuccess, (state, { aiDMSuccData }) => {
    return {
      ...state,
      ...{ aiDMSuccData }
    };
  }),
  on(updateAIDMFail, (state, { aiDMFailData }) => {
    return {
      ...state,
      ...{ aiDMFailData }
    };
  }),
  on(generateModelForTablePromptSuccess, (state, { generateModelForTablePromptSuccData }) => {
    return {
      ...state,
      ...{ generateModelForTablePromptSuccData }
    };
  }),
  on(generateModelForTablePromptFailure, (state, { generateModelForTablePromptFailData }) => {
    return {
      ...state,
      ...{ generateModelForTablePromptFailData }
    };
  }),
  on(generateModelForFieldPromptSuccess, (state, { generateModelForFieldPromptSuccData }) => {
    return {
      ...state,
      ...{ generateModelForFieldPromptSuccData }
    };
  }),
  on(generateModelForFieldPromptFailure, (state, { generateModelForFieldPromptFailData }) => {
    return {
      ...state,
      ...{ generateModelForFieldPromptFailData }
    };
  })
);
